<template>
    <div class="wrapping">
      <div class="item-title">
        <p v-if="props.translate">対応事例</p>
        <p v-else>Support Examples</p>
      </div>
      <div v-if="props.translate" class="item-detail">
        <p>【2020年代】</p>
        <p>建設機械レンタル管理システムリニューアル</p>
        <p>製薬会社向け購買システム構築,他社カタログ連携</p>
        <p>【2010年代】</p>
        <p>動画配信サイト電子決済機能作成</p>
        <p>不動産会社向け物件紹介サイト会員機能等の作成</p>
        <p>米国SNS日本版FPアプリ作成</p>
        <p>電力会社/震災に伴うシステム改修</p>
        <p>【2000年代】</p>
        <p>商社/会計システムリニューアル</p>
        <p>旅行会社/航空会社合併に伴うシステム改修</p>
        <p>携帯電話会社/窓口システムOSバージョンアップ対応（Window3.1から2000）</p>
        <p>お弁当販売会社/季節商品注文ページ作成/伝票出力機能作成</p>
        <p>【1990年代】</p>
        <p>POSレジ2000年対応</p>
        <p>テーマパーク団体予約システム構築/チケット発行機能作成</p>
        <p>外国為替システム/被仕向送金機能改修</p>
        <p class="mt-10">※改組前（当社設立前）のものを含みます。</p>
        <p>※規模が大きい案件では部分的に対応しております。</p>
      </div>
      <div v-else class="item-detail-en">
        <p v-text="examplesEn"></p>
      </div>
    </div>
  </template>
    
  <script lang="ts" setup>
  import { ref } from 'vue'

  const props = defineProps(['translate']) 

  const examplesEn = ref(`準備中`)
  
  </script>
  
  <style scoped>
  .wrapping {
    position: absolute;
    left: 0;
    width: 100%;
    height: 90%;
    margin: 20px 0;
    background-color: #f9f9f9;
    opacity: 0.9;
  }
  .item-title {
    color: #f9ffff;
    font-size: 1.1rem;
    text-align: center;
    background-color: #2c3e50;
    margin-top: 15px;
    padding: 5px;
    opacity: 0.8;
  }
  .item-detail {
    padding: 10px;
    font-size: 0.7rem;
  }
  .item-detail-en {
    padding: 15px;
  }
  .img-mtg {
    margin: 10px;
    text-align: left;
  }
  .img-mtg img {
    height: 100px;
  }
  .img-staff :hover {
    opacity: 0.5;
  }
  p{
    margin: 0;
  }
  p.ttl{
    font-weight: bold;
    margin: 20px 0 5px;
  }
  .mt-10 {
    margin-top: 10px;
  }
  </style>
    